import { Component, OnInit, signal } from '@angular/core';
import { MessageBarStore, Modal, SOFTLINE_FEATURE_MESSAGE_BAR, UiCoreModule } from '@softline/ui-core';
import { CommonModule } from '@angular/common';
import { Artstamm } from '../../types/artstamm';
import { WiegungService } from '../../services/wiegung-service';
import { Store } from '@softline/core';
import { Material } from '../../types/material';

@Component({
    selector: 'soft-extra-material-list-selection-dialog',
    imports: [CommonModule, UiCoreModule],
    templateUrl: './extra-material-list-selection-dialog.component.html',
    styleUrl: './extra-material-list-selection-dialog.component.scss'
})
export class ExtraMaterialListSelectionDialogComponent implements OnInit, Modal<any> {

  close!: (result: any) => void;
  id!: number;

  readonly loading = signal<boolean>(false)
  readonly extraMaterials = signal<Artstamm[]>([]);
  readonly legierungen = signal<{ charge: string, id: number }[]>([]);
  readonly selectedLegierung = signal<{ charge: string; id: number } | null>(null);

  constructor(private service: WiegungService<Material>, private store: Store) { }

  async ngOnInit(): Promise<void> {
    this.loading.set(true);

    try {
      const result = await this.service.getCustomMaterials();
      this.extraMaterials?.set(result?.artikel);
      this.legierungen?.set(result?.chargen);
      this.selectedLegierung?.set(result?.chargen[0] ?? null);
      this.loading?.set(false);
    } catch (e) {
      this.loading?.set(false);
      await this.store.dispatch(
        SOFTLINE_FEATURE_MESSAGE_BAR,
        MessageBarStore.actions.error,
        {
          title: 'Fehler',
          message: 'Materialien konnten nicht geladen werden!'
        }
      )
    }
  }

  registerCloseHandler(handler: (result: any) => void) {
    this.close = handler;
  }

  select(item: any): void {
    this.close(item);
  }
}
